<template>
  <section
    id="events-hero-section"
    class="hero-section"
  >
    <div class="container">
      <div class="first-column">
        <h1 class="title">
          Stay tuned on
          <br />
          Proxify events
        </h1>
        <p class="subtitle">
          Share knowledge and level up your skills with other tech experts.
        </p>
      </div>
      <div class="second-column">
        <div class="card-wrapper">
          <HeroCard />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import HeroCard from './HeroCard/HeroCard.vue';

export default {
  components: {
    HeroCard,
  },
  data() {
    return {
      cubeAnimated: '',
      illustrationAnimated: '',
      observer: null,
    };
  },
  mounted() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 1,
    };

    const callback = (entries) => {
      if (entries[0].isIntersecting) {
        this.cubeAnimated = '';
        this.illustrationAnimated = '';
      } else {
        this.cubeAnimated = 'cube-animated';
        this.illustrationAnimated = 'illustration-animated';
      }
    };

    this.observer = new IntersectionObserver(callback.bind(this), options);
    const section = document.querySelector('#events-hero-section');
    this.observer.observe(section);
  },
};
</script>

<style lang="scss" scoped>
@import './HeroSection.scss';
</style>
